import { z } from 'zod';

import type { ServiceFormItem } from '../../../capabilities/service/types';

export const BareMetalProvisioningModeSchema = z.enum(['Install', 'Adopt']);

export const BareMetalSpecSchema = z.object({
  name: z.string(),
  description: z.string().optional(),
  workspace: z.string().optional(),
  datacenter: z.string().optional(),
  optionMeta: z.record(z.string(), z.unknown()).optional(),
  bmsNode: z.string().optional(),
  powerPolicy: z.string().optional(),
  /** 首次创建系统交付方式；缺省等价 Install */
  provisioning: z
    .object({
      mode: BareMetalProvisioningModeSchema.optional(),
    })
    .optional(),
  /** 系统安装/重装引导方式；缺省等价 PXE */
  boot: z
    .object({
      mode: z.string().optional(),
      revision: z.string().optional(),
    })
    .optional(),
  network: z.object({
    vpc: z.object({ name: z.string() }).optional(),
    subnet: z.object({ name: z.string().optional() }).optional(),
    securitygroup: z.object({ name: z.string().optional() }).optional(),
    /** Adopt 时前端必填（节点有静态 IP 则回填只读）；Install 不写入 */
    staticIpv4: z.string().optional(),
    services: z.array(z.custom<ServiceFormItem>()).optional(),
  }),
  systemVolume: z
    .object({
      image: z.string().optional(),
      os: z.string().optional(),
      version: z.string().optional(),
      architecture: z.string().optional(),
      kernel: z.string().optional(),
      initrd: z.string().optional(),
      root: z.string().optional(),
      diskType: z.string().optional(),
    })
    .optional(),
  account: z
    .object({
      user: z
        .array(
          z.object({
            name: z.string(),
            groups: z.array(z.string()).optional(),
            sudo: z.string().optional(),
            passwd: z.string().optional(),
            sshKey: z
              .object({
                privatedKey: z.string().optional(),
              })
              .optional(),
          }),
        )
        .optional(),
    })
    .optional(),
  system: z
    .object({
      options: z
        .object({
          containerDeployConfig: z.union([z.string(), z.record(z.string(), z.unknown())]).optional(),
        })
        .optional(),
    })
    .optional(),
});

export type BareMetalSpec = z.infer<typeof BareMetalSpecSchema>;

export type BareMetalApiPayload = Record<string, unknown>;
